<div class="car-detail__gallery">
  <button class="car-detail__gallery-back" type="button" (click)="back()">
    <app-icon [icon]="'arrow-back-shadow'" [width]="40">{{ 'globals.prev' | translate }}</app-icon>
  </button>
  <div class="car-detail__gallery-main">
    <div class="car-detail__gallery-main-content">
      <span class="car-detail__gallery-main-item">
        <button class="car-detail__gallery-arrow car-detail__gallery-arrow--prev" type="button" (click)="prev(); gtm('listovani')">
          <app-icon class="car-detail__gallery-arrow-icon" [icon]="'chevron-left-shadow'" [fit]="true">{{ 'globals.prev' | translate }}</app-icon>
        </button>
        <div #gallerySwiper class="car-detail__gallery-swiper" (scroll)="swipe()">
          @if (threeSixtyActive && threeSixtyUrl) {
            <iframe class="car-detail__gallery-threesixty" [src]="threeSixtyUrl" [title]="'360'"></iframe>
          }
          @for (thumbnail of items; track $index; let i = $index) {
            <div class="car-detail__gallery-wrap" [ngClass]="{ 'car-detail__gallery-wrap--hidden': threeSixtyActive && threeSixtyUrl, 'car-detail__gallery-wrap--active': i == active }">
              <app-image
                class="car-detail__gallery-photo car-detail__gallery-photo--main"
                [ngClass]="{ 'car-detail__gallery-photo--hidden': !loaded }"
                [src]="thumbnail.data.src"
                [sizes]="'375w, 425w, 640w, 750w, 828w, 900w, 1080w, 1290w, 1350w, 1600w'"
                [alt]="thumbnail.data.alt"
                [lightbox]="active"
                [gallery]="galleryId"
                [fill]="true"
                [priority]="$first"
                [placeholder]="true"
                [preload-image-parent]="'.car-detail__gallery-swiper'"
                (loaded)="imageLoaded()"
                (error)="imageLoaded()"
                (click)="gtm('big_open')"
                app-ripple
              ></app-image>
            </div>
          }
          @if (!loaded) {
            <app-loader class="car-detail__gallery-loader"></app-loader>
          }
        </div>
        <button class="car-detail__gallery-arrow car-detail__gallery-arrow--next" type="button" (click)="next(); gtm('listovani')">
          <app-icon class="car-detail__gallery-arrow-icon" [icon]="'chevron-right-shadow'" [fit]="true">{{ 'globals.next' | translate }}</app-icon>
        </button>
      </span>

      <div class="car-detail__gallery-buttons">
        <button class="car-detail__gallery-buttons-item car-detail__gallery-buttons-item--square" type="button" (click)="share()">
          <app-icon [icon]="'share'" [width]="24">{{ 'globals.share' | translate }}</app-icon>
        </button>
        @if (pdf) {
          <a class="car-detail__gallery-buttons-item" [href]="pdf" download>
            <app-icon [icon]="'pdf'" [width]="24">pdf</app-icon>
            <span class="car-detail__gallery-buttons-text">{{ 'carDetail.technicalSpecification' | translate }}</span>
          </a>
        }
        @if (threeSixtyUrl) {
          <button class="car-detail__gallery-buttons-item car-detail__gallery-buttons-item--square" type="button" (click)="threeSixtyOpen()">
            <app-icon [icon]="'threesixty'" [width]="24">360</app-icon>
          </button>
        }
      </div>
    </div>
    <div class="car-detail__gallery-thumbnails car-detail__gallery-thumbnails--desktop">
      <div class="car-detail__gallery-thumbnails-controls">
        <button class="car-detail__gallery-thumbnails-controls-item car-detail__gallery-thumbnails-controls-item--desktop" [ngClass]="{ 'car-detail__gallery-thumbnails-controls-item--hidden': scrollStart }" type="button" (click)="scroll('up')">
          <app-icon [icon]="'chevron'" [width]="24" [rotate]="-90">{{ 'globals.prev' | translate }}</app-icon>
        </button>
        <button class="car-detail__gallery-thumbnails-controls-item car-detail__gallery-thumbnails-controls-item--desktop" [ngClass]="{ 'car-detail__gallery-thumbnails-controls-item--hidden': scrollEnd }" type="button" (click)="scroll('down')">
          <app-icon [icon]="'chevron'" [width]="24" [rotate]="90">{{ 'globals.next' | translate }}</app-icon>
        </button>
      </div>
      <div #thumbnailsInner class="car-detail__gallery-thumbnails-inner" (scroll)="scrollCheck()">
        @if (threeSixtyUrl) {
          <span class="car-detail__gallery-thumbnails-item" [ngClass]="{ 'car-detail__gallery-thumbnails-item--active': threeSixtyActive }" (click)="threeSixtyOpen()" app-ripple>
            <app-image class="car-detail__gallery-photo" [src]="items[0].data.thumb" [placeholder]="items[0].data.placeholder" [alt]="items[0].data.alt" [fill]="true" [priority]="true"></app-image>
            <app-icon class="car-detail__gallery-thumbnails-item-icon" [icon]="'threesixty'" [fit]="true"></app-icon>
          </span>
        }
        @for (thumbnail of items; track $index; let i = $index) {
          <span class="car-detail__gallery-thumbnails-item" [ngClass]="{ 'car-detail__gallery-thumbnails-item--active': i == active && !threeSixtyActive }" (click)="change(i, $event); gtm('zalozka_fotka')" app-ripple>
            <app-image class="car-detail__gallery-photo" [src]="thumbnail.data.thumb" [placeholder]="thumbnail.data.placeholder" [alt]="thumbnail.data.alt" [fill]="true" [priority]="$first"></app-image>
          </span>
        }
      </div>
    </div>
  </div>

  <div class="car-detail__gallery-content">
    <ng-content></ng-content>
  </div>

  <div class="car-detail__gallery-bottom">
    <div class="car-detail__gallery-bottom-left" [ngClass]="{ 'car-detail__gallery-bottom-left--end': scrollEnd }">
      <div class="car-detail__gallery-thumbnails car-detail__gallery-thumbnails--mobile">
        <div class="car-detail__gallery-thumbnails-controls">
          <button class="car-detail__gallery-thumbnails-controls-item" [ngClass]="{ 'car-detail__gallery-thumbnails-controls-item--hidden': scrollStart }" type="button" (click)="scroll('left')">
            <app-icon [icon]="'chevron-left-shadow'" [width]="24" [height]="24">{{ 'globals.prev' | translate }}</app-icon>
          </button>
          <button class="car-detail__gallery-thumbnails-controls-item" [ngClass]="{ 'car-detail__gallery-thumbnails-controls-item--hidden': scrollEnd }" type="button" (click)="scroll('right')">
            <app-icon [icon]="'chevron-right-shadow'" [width]="24" [height]="24">{{ 'globals.next' | translate }}</app-icon>
          </button>
        </div>
        <div #thumbnailsInnerMobile class="car-detail__gallery-thumbnails-inner" (scroll)="scrollCheck()">
          @if (threeSixtyUrl) {
            <span class="car-detail__gallery-thumbnails-item" [ngClass]="{ 'car-detail__gallery-thumbnails-item--active': threeSixtyActive }" (click)="threeSixtyOpen()" app-ripple>
              <app-image class="car-detail__gallery-photo" [src]="items[0].data.thumb" [alt]="items[0].data.alt" [fill]="true" [priority]="true"></app-image>
              <app-icon class="car-detail__gallery-thumbnails-item-icon" [icon]="'threesixty'" [fit]="true"></app-icon>
            </span>
          }
          @for (thumbnail of items; track $index; let i = $index) {
            <span class="car-detail__gallery-thumbnails-item" [ngClass]="{ 'car-detail__gallery-thumbnails-item--active': i == active && !threeSixtyActive }" (click)="change(i, $event); gtm('zalozka_fotka')" app-ripple>
              <app-image class="car-detail__gallery-photo" [src]="thumbnail.data.thumb" [alt]="thumbnail.data.alt" [fill]="true" [priority]="$first && !threeSixtyUrl"></app-image>
            </span>
          }
        </div>
      </div>
    </div>
    <button class="car-detail__gallery-bottom-button" type="button" (click)="openLightbox(active)">
      {{ 'carDetail.gallery.title' | translate }}
      <span class="car-detail__gallery-bottom-button-count">
        <app-icon [icon]="'camera'" [width]="16"></app-icon>
        {{ active + 1 }} / {{ items.length }}
      </span>
    </button>
  </div>
</div>

<div class="car-detail__gallery-lightbox-item" *galleryItemDef="let item">
  <img class="car-detail__gallery-lightbox-image" [src]="item?.src" [srcset]="item?.src | srcset:['375w', '425w', '640w', '750w', '828w', '900w', '1080w', '1290w', '1350w', '1600w']" [app-preload-image]="'.g-slider'" loading="lazy">
</div>